import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import AvatarIcon from '@atlaskit/icon/core/person-avatar';

import type { LinkItemConfig, NavItemConfig } from '../../common/types';

import { FOR_YOU_TEST_ID } from './constants';
import { messages } from './messages';

interface ForYouProps {
	href?: string;
	isSelected?: boolean;
	onClick?: React.MouseEventHandler<HTMLElement>;
}

export default function makeForYouNavItem({
	href,
	isSelected,
	onClick,
}: ForYouProps): NavItemConfig {
	const icon = <AvatarIcon label="" />;

	const common: Pick<LinkItemConfig, 'testId' | 'isSelected' | 'elemBefore' | 'children'> = {
		testId: FOR_YOU_TEST_ID,
		isSelected,
		elemBefore: icon,
		children: <FormattedMessage {...messages.forYouLabel} />,
	};

	return href
		? {
				type: 'link',
				href,
				onClick,
				...common,
			}
		: {
				type: 'button',
				onClick,
				...common,
			};
}
